export enum CreatePaymentOrderActionTypes {
  CREATING = 'payment/CREATING',
  CREATED = 'payment/CREATED',
}
